<template>

  <svg
    t="1639130406253"
    class="icon"
    viewBox="0 0 1504 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M390.63774936 970.66666667C198.80324716 970.66666667 42.82785185 814.57408479 42.82785185 622.62239604 42.82785185 444.02998198 178.06121529 296.60921042 351.61460341 277.03904417 713.60408248-257.09758332 1191.37394528 120.9464623 1176.02249717 464.65482823c209.99842875-96.79615031 479.99640844 371.59878186 42.7731178 506.01183844H390.63774936m-259.80274315-348.04427063c0 143.31924 116.48350311 259.80274313 259.80274315 259.80274313h828.15786562c300.700875-145.3114125 63.74952281-415.42657875-68.67136126-318.6304275-17.10924656 43.1246775-40.54657125 78.86659781-71.60102717 119.64754219-18.28111311-16.6405003-47.81214187-40.78094437-67.03074846-57.30425908 33.98412094-39.96063844 80.74158375-138.51458813 80.74158376-218.67023905 0-185.74079719-332.69282343-520.89453938-647.80765218-128.08497844 36.44503969 6.09370406 231.0920203 96.67896375 265.77926063 114.96007688-9.49211625 21.0935925-28.82790935 60.93704438-39.96063845 78.5150372-77.34317155-39.1403325-210.34998845-109.92105281-279.60728249-110.03823845-143.31924 0.23437312-259.80274313 116.71787625-259.80274315 259.80274312" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconCloud',
} as DefineComponent
</script>